import { fireCustomEvent } from '~helpers/custom-events';
import events from '~variables/custom-events.json';
import axios from '~helpers/axios';

export default function staticHash(host = '') {
  return axios({
    method: 'get',
    url: `${host}/microapp-home-page/static-hash`,
    timeout: 3000,
  })
    .then(response => {
      window.hurricane = window.hurricane || {};
      window.hurricane.staticHash = response.data;
      fireCustomEvent(events.staticHashInitialised.name);
    })
    .catch(() => {
      window.hurricane = window.hurricane || {};
      window.hurricane.staticHash = {
        modal: 'latest',
        trak: 'latest',
        trans: 'latest',
        wulai: '1.3.min',
      };

      fireCustomEvent(events.staticHashInitialised.name);
    });
}
